export enum ProgressIndicatorType {
  HorizontalSteps = 'Horizontal Steps', // default
  Circle = 'Circle',
}
